<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="무통장 입금 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <lp-adm-drop-input :data.sync="partners"
                                   :selectVal="partnerName"
                                   @onSelect="res => nopass.partner_id = res.value"
                                   placeholder="검색 후 선택"
                                   listAlign="center"
                                   style="display:inline-block; margin-right:12px;"></lp-adm-drop-input>
              </div>
              <div class="column is-full">
                <admin-form-item label="은행명">
                  <input class="input"
                         style="width:300px"
                         :value="nopass.bank"
                         @input="e=>nopass.bank=e.target.value"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="계좌번호">
                  <input class="input"
                         style="width:300px"
                         :value="nopass.account_number"
                         @input="e=>nopass.account_number=e.target.value"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="예금주">
                  <input class="input"
                         style="width:300px"
                         :value="nopass.name"
                         @input="e=>nopass.name=e.target.value"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="사용상태">
                  <lp-radio :val.sync="nopass.enable_use"
                            label_name="label"
                            value_name="value"
                            :data="[{label:'사용함', value:true},{label:'사용안함', value:false}]"
                  ></lp-radio>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";

  export default {
    components: {
      LpAdmDropInput,
      LpRadio},
    data() {
      return {
        partners: [],
        nopass: {
          bank: "",
          account_number:"",
          name: "",
          enable_use: "",
          partner_id: ""
        }
      }
    },
    created(){
      this.getData();

      if(this.$store.getters.mode==='admin') {
        this.$axios.get('admin/partner/simple').then(res => {
          this.partners = res.data;
        })
      }
    },
    computed: {
      partnerName(){
        if(this.partners.length>0){
          for(let i=0; i<this.partners.length; i++){
            if(this.partners[i].value===this.nopass.partner_id){
              return this.partners[i].label;
              break;
            }
          }
        }
      }
    },
    methods:{
      getData(){
        this.$axios.get(this.getUrl(`commerce/nopassbook/${this.$route.query.id}`)).then(res=>{
          if(res.status===200){
            this.nopass = res.data;
          }
        })
      },
      saveData(){
        if(this.$route.query.id){
          this.$axios.patch(this.getUrl(`commerce/nopassbook/${this.$route.query.id}`), this.nopass).then(res=>{
            if(res.status===200){
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('commerce/nopass'));
            }
          })
        }
        else {
          this.$axios.post(this.getUrl('commerce/nopassbook'), this.nopass).then(res=>{
            if(res.status===200){
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('commerce/nopass'));
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
